/* 🤖 this file was generated by svg-to-ts */
export const sbIconsArrowDown: {
  name: 'arrow-down';
  data: string;
} = {
  name: 'arrow-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="M19.5074 8.8174a1.66524 1.66524 0 0 0-1.1823-.49259c-.2199 0-.4376.04353-.6405.12807a1.666 1.666 0 0 0-.5419.36452l-5.4788 5.4955V1.67329A1.66536 1.66536 0 0 0 9.99858.00799a1.6653 1.6653 0 0 0-1.66529 1.6653V14.3129L2.85447 8.8174a1.67212 1.67212 0 0 0-2.36472 2.3647l8.32647 8.3265a1.666 1.666 0 0 0 .54955.3497 1.5654 1.5654 0 0 0 1.26563 0c.2044-.0793.3912-.1981.5495-.3497l8.3265-8.3265c.1561-.1548.28-.339.3645-.5419A1.664 1.664 0 0 0 20 9.99976c0-.21984-.0435-.4375-.1281-.64043a1.664 1.664 0 0 0-.3645-.54193"/></svg>`
};
